import { c as _c } from "react/compiler-runtime";
import { COUNTRIES, US_STATES_AND_ARMED_FORCES, VAULT_DOT_SEPARATOR, type VaultFormData } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useCountryName } from '@/idv2/hooks/use-country-name';
type ResidentialAddressProps = {
  locale: Locale;
  residentialAddressCountries?: string[];
  disabledDis: DataIdentifier[];
};
export const ResidentialAddress = t0 => {
  const $ = _c(137);
  const {
    locale,
    residentialAddressCountries,
    disabledDis
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const getCountryName = useCountryName();
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== disabledDis || $[2] !== getCountryName || $[3] !== locale || $[4] !== residentialAddressCountries || $[5] !== t) {
    const filteredCountries = residentialAddressCountries?.length ? COUNTRIES.filter(c => residentialAddressCountries.includes(c.value)) : COUNTRIES;
    t13 = "flex flex-col gap-4";
    let t15;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <IcoBuilding24 color="primary" />;
      $[20] = t15;
    } else {
      t15 = $[20];
    }
    let t16;
    if ($[21] !== t) {
      t16 = t(_temp);
      $[21] = t;
      $[22] = t16;
    } else {
      t16 = $[22];
    }
    if ($[23] !== t16) {
      t14 = <div className="flex gap-1 items-center">{t15}<span className="text-label-2 text-primary">{t16}</span></div>;
      $[23] = t16;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    T0 = Form.AddressLines;
    t3 = "id";
    t4 = VAULT_DOT_SEPARATOR;
    t5 = true;
    let t17;
    if ($[25] !== disabledDis) {
      t17 = disabledDis.includes("id.country");
      $[25] = disabledDis;
      $[26] = t17;
    } else {
      t17 = $[26];
    }
    let t18;
    if ($[27] !== disabledDis) {
      t18 = disabledDis.includes("id.address_line1");
      $[27] = disabledDis;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    let t19;
    if ($[29] !== disabledDis) {
      t19 = disabledDis.includes("id.address_line2");
      $[29] = disabledDis;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    let t20;
    if ($[31] !== disabledDis) {
      t20 = disabledDis.includes("id.city");
      $[31] = disabledDis;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    let t21;
    if ($[33] !== disabledDis) {
      t21 = disabledDis.includes("id.state");
      $[33] = disabledDis;
      $[34] = t21;
    } else {
      t21 = $[34];
    }
    let t22;
    if ($[35] !== disabledDis) {
      t22 = disabledDis.includes("id.zip");
      $[35] = disabledDis;
      $[36] = t22;
    } else {
      t22 = $[36];
    }
    if ($[37] !== t17 || $[38] !== t18 || $[39] !== t19 || $[40] !== t20 || $[41] !== t21 || $[42] !== t22) {
      t6 = {
        country: t17,
        addressLine1: t18,
        addressLine2: t19,
        city: t20,
        state: t21,
        zip: t22
      };
      $[37] = t17;
      $[38] = t18;
      $[39] = t19;
      $[40] = t20;
      $[41] = t21;
      $[42] = t22;
      $[43] = t6;
    } else {
      t6 = $[43];
    }
    if ($[44] !== locale) {
      t7 = {
        locale
      };
      $[44] = locale;
      $[45] = t7;
    } else {
      t7 = $[45];
    }
    t8 = filteredCountries;
    t9 = US_STATES_AND_ARMED_FORCES;
    let t23;
    if ($[46] !== t) {
      t23 = t(_temp2);
      $[46] = t;
      $[47] = t23;
    } else {
      t23 = $[47];
    }
    let t24;
    if ($[48] !== t) {
      t24 = t(_temp3);
      $[48] = t;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== t) {
      t25 = t(_temp4);
      $[50] = t;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    let t26;
    if ($[52] !== t) {
      t26 = t(_temp5);
      $[52] = t;
      $[53] = t26;
    } else {
      t26 = $[53];
    }
    let t27;
    if ($[54] !== t) {
      t27 = t(_temp6);
      $[54] = t;
      $[55] = t27;
    } else {
      t27 = $[55];
    }
    let t28;
    if ($[56] !== t) {
      t28 = t(_temp7);
      $[56] = t;
      $[57] = t28;
    } else {
      t28 = $[57];
    }
    let t29;
    if ($[58] !== t) {
      t29 = t(_temp8);
      $[58] = t;
      $[59] = t29;
    } else {
      t29 = $[59];
    }
    let t30;
    if ($[60] !== t) {
      t30 = t(_temp9);
      $[60] = t;
      $[61] = t30;
    } else {
      t30 = $[61];
    }
    let t31;
    if ($[62] !== t) {
      t31 = t(_temp10);
      $[62] = t;
      $[63] = t31;
    } else {
      t31 = $[63];
    }
    if ($[64] !== t23 || $[65] !== t24 || $[66] !== t25 || $[67] !== t26 || $[68] !== t27 || $[69] !== t28 || $[70] !== t29 || $[71] !== t30 || $[72] !== t31) {
      t10 = {
        country: t23,
        addressLine1: t24,
        addressLine1International: t25,
        addressLine2: t26,
        addressLine2International: t27,
        city: t28,
        state: t29,
        stateInternational: t30,
        zip: t31
      };
      $[64] = t23;
      $[65] = t24;
      $[66] = t25;
      $[67] = t26;
      $[68] = t27;
      $[69] = t28;
      $[70] = t29;
      $[71] = t30;
      $[72] = t31;
      $[73] = t10;
    } else {
      t10 = $[73];
    }
    let t32;
    if ($[74] !== t) {
      t32 = t(_temp11);
      $[74] = t;
      $[75] = t32;
    } else {
      t32 = $[75];
    }
    let t33;
    if ($[76] !== t) {
      t33 = t(_temp12);
      $[76] = t;
      $[77] = t33;
    } else {
      t33 = $[77];
    }
    let t34;
    if ($[78] !== t) {
      t34 = t(_temp13);
      $[78] = t;
      $[79] = t34;
    } else {
      t34 = $[79];
    }
    let t35;
    if ($[80] !== t) {
      t35 = t(_temp14);
      $[80] = t;
      $[81] = t35;
    } else {
      t35 = $[81];
    }
    let t36;
    if ($[82] !== t) {
      t36 = t(_temp15);
      $[82] = t;
      $[83] = t36;
    } else {
      t36 = $[83];
    }
    let t37;
    if ($[84] !== t) {
      t37 = t(_temp16);
      $[84] = t;
      $[85] = t37;
    } else {
      t37 = $[85];
    }
    let t38;
    if ($[86] !== t) {
      t38 = t(_temp17);
      $[86] = t;
      $[87] = t38;
    } else {
      t38 = $[87];
    }
    let t39;
    if ($[88] !== t) {
      t39 = t(_temp18);
      $[88] = t;
      $[89] = t39;
    } else {
      t39 = $[89];
    }
    if ($[90] !== t32 || $[91] !== t33 || $[92] !== t34 || $[93] !== t35 || $[94] !== t36 || $[95] !== t37 || $[96] !== t38 || $[97] !== t39) {
      t11 = {
        country: t32,
        addressLine1: t33,
        addressLine2: t34,
        addressLine2International: t35,
        city: t36,
        state: t37,
        stateInternational: t38,
        zip: t39
      };
      $[90] = t32;
      $[91] = t33;
      $[92] = t34;
      $[93] = t35;
      $[94] = t36;
      $[95] = t37;
      $[96] = t38;
      $[97] = t39;
      $[98] = t11;
    } else {
      t11 = $[98];
    }
    let t40;
    if ($[99] !== t) {
      t40 = t(_temp19);
      $[99] = t;
      $[100] = t40;
    } else {
      t40 = $[100];
    }
    let t41;
    if ($[101] !== t) {
      t41 = t(_temp20);
      $[101] = t;
      $[102] = t41;
    } else {
      t41 = $[102];
    }
    let t42;
    if ($[103] !== t) {
      t42 = t(_temp21);
      $[103] = t;
      $[104] = t42;
    } else {
      t42 = $[104];
    }
    let t43;
    if ($[105] !== t) {
      t43 = t(_temp22);
      $[105] = t;
      $[106] = t43;
    } else {
      t43 = $[106];
    }
    let t44;
    if ($[107] !== t) {
      t44 = t(_temp23);
      $[107] = t;
      $[108] = t44;
    } else {
      t44 = $[108];
    }
    let t45;
    if ($[109] !== t) {
      t45 = t(_temp24);
      $[109] = t;
      $[110] = t45;
    } else {
      t45 = $[110];
    }
    if ($[111] !== t40 || $[112] !== t41 || $[113] !== t42 || $[114] !== t43 || $[115] !== t44 || $[116] !== t45) {
      t12 = {
        country: t40,
        addressLine1: t41,
        addressLine2: t42,
        city: t43,
        state: t44,
        zip: t45
      };
      $[111] = t40;
      $[112] = t41;
      $[113] = t42;
      $[114] = t43;
      $[115] = t44;
      $[116] = t45;
      $[117] = t12;
    } else {
      t12 = $[117];
    }
    t2 = t(_temp25, {
      countryName: getCountryName(filteredCountries[0]?.value)
    });
    $[1] = disabledDis;
    $[2] = getCountryName;
    $[3] = locale;
    $[4] = residentialAddressCountries;
    $[5] = t;
    $[6] = T0;
    $[7] = t10;
    $[8] = t11;
    $[9] = t12;
    $[10] = t13;
    $[11] = t14;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[6];
    t10 = $[7];
    t11 = $[8];
    t12 = $[9];
    t13 = $[10];
    t14 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t15;
  if ($[118] !== t2) {
    t15 = {
      countryDisabled: t2
    };
    $[118] = t2;
    $[119] = t15;
  } else {
    t15 = $[119];
  }
  let t16;
  if ($[120] !== T0 || $[121] !== t10 || $[122] !== t11 || $[123] !== t12 || $[124] !== t15 || $[125] !== t3 || $[126] !== t4 || $[127] !== t5 || $[128] !== t6 || $[129] !== t7 || $[130] !== t8 || $[131] !== t9) {
    t16 = <T0 prefix={t3} vaultSeparator={t4} required={t5} disabled={t6} l10n={t7} countries={t8} stateOptions={t9} labels={t10} placeholders={t11} errors={t12} hints={t15} />;
    $[120] = T0;
    $[121] = t10;
    $[122] = t11;
    $[123] = t12;
    $[124] = t15;
    $[125] = t3;
    $[126] = t4;
    $[127] = t5;
    $[128] = t6;
    $[129] = t7;
    $[130] = t8;
    $[131] = t9;
    $[132] = t16;
  } else {
    t16 = $[132];
  }
  let t17;
  if ($[133] !== t13 || $[134] !== t14 || $[135] !== t16) {
    t17 = <div className={t13}>{t14}{t16}</div>;
    $[133] = t13;
    $[134] = t14;
    $[135] = t16;
    $[136] = t17;
  } else {
    t17 = $[136];
  }
  return t17;
};
function _temp($) {
  return $.fields.address.title;
}
function _temp2($_0) {
  return $_0.fields.address.country.label;
}
function _temp3($_1) {
  return $_1.fields.address.addressLine1.label;
}
function _temp4($_2) {
  return $_2.fields.address.addressLine1.internationalLabel;
}
function _temp5($_3) {
  return $_3.fields.address.addressLine2.label;
}
function _temp6($_4) {
  return $_4.fields.address.addressLine2.internationalLabel;
}
function _temp7($_5) {
  return $_5.fields.address.city.label;
}
function _temp8($_6) {
  return $_6.fields.address.state.label;
}
function _temp9($_7) {
  return $_7.fields.address.state.internationalLabel;
}
function _temp10($_8) {
  return $_8.fields.address.zip.label;
}
function _temp11($_9) {
  return $_9.fields.address.country.placeholder;
}
function _temp12($_10) {
  return $_10.fields.address.addressLine1.placeholder;
}
function _temp13($_11) {
  return $_11.fields.address.addressLine2.placeholder;
}
function _temp14($_12) {
  return $_12.fields.address.addressLine2.internationalPlaceholder;
}
function _temp15($_13) {
  return $_13.fields.address.city.placeholder;
}
function _temp16($_14) {
  return $_14.fields.address.state.placeholder;
}
function _temp17($_15) {
  return $_15.fields.address.state.internationalPlaceholder;
}
function _temp18($_16) {
  return $_16.fields.address.zip.placeholder;
}
function _temp19($_17) {
  return $_17.fields.address.country.error;
}
function _temp20($_18) {
  return $_18.fields.address.addressLine1.error;
}
function _temp21($_19) {
  return $_19.fields.address.addressLine2.error;
}
function _temp22($_20) {
  return $_20.fields.address.city.error;
}
function _temp23($_21) {
  return $_21.fields.address.state.error;
}
function _temp24($_22) {
  return $_22.fields.address.zip.error;
}
function _temp25($_23) {
  return $_23.fields.address.country.disabledHint;
}